import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import "moment-timezone";
import * as moment from 'moment/moment';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from '../../core/components';
import { SettingModel } from '../../models';
import { TenantEmailSettingModel, TenantSettingModel } from '../../models/tenantSettingModel';
import { CustomTypeService, SettingsService, TenantService, Type3Service } from '../../services';
import { IncidentTypeService } from '../../services/incident-type.service';

@Component({
    selector: 'app-setting-edit',
    templateUrl: './setting-edit.component.html',
    styleUrls: ['./setting-edit.component.scss', '../layout/layout.component.scss']
})
export class SettingEditComponent extends BaseComponent implements OnInit {
    type1: string = "Type 1";
    type2: string = "Type 2";
    type3: string = "Type 3";
    tenantSettingModel: TenantSettingModel;
    tenantEmailSettingModel: TenantEmailSettingModel;
    incidenttypes: any[];
    type3List: any[];
    publicContacts: any[] = [];
    customTypes: any[];
    public startRondModel: any = {
        type1: '',
        type2: '',
        type3: '',
        description: '',
        guard: ''
    };
    public stopRondModel: any = {
        type1: '',
        type2: '',
        type3: '',
        description: '',
        guard: ''
    };
    public option1: any = {
        enabled: false,
        name: ''
    };
    public option2: any = {
        enabled: false,
        name: ''
    };
    public option3: any = {
        enabled: false,
        name: '',
        id: 0
    };
    public modalIdData: number;
    specialOptions: any[] = [];
    offsetTmz: any[];
    SpecialOptions: string = "Special Option";
    showSpinner: boolean;
    model: SettingModel = new SettingModel();
    type1List: any;
    timezones: any[];
    tenantTypeList: any = [];
    jobTitleList: any = [];
    //notifyActions: boolean;
    constructor(private route: ActivatedRoute,
        private toastr: ToastsManager,
        private incidentTypeService: IncidentTypeService,
        private router: Router,
        private settingService: SettingsService,
        private customTypeService: CustomTypeService,
        private type3Service: Type3Service,
        public activeModal: NgbActiveModal,
        private tenantService: TenantService,
        private location: Location) {

        super(router);
    }

    imageData: string | ArrayBuffer;
    ngOnInit() {
        this.tenantSettingModel = new TenantSettingModel();
        this.tenantEmailSettingModel = new TenantEmailSettingModel();
        this.timezones = moment.tz.names();
        this.offsetTmz = [];

        for (var i in this.timezones) {
            this.offsetTmz.push("(UTC" + moment.utc().tz(this.timezones[i]).format('Z') + ") " + this.timezones[i]);
        }
        this.offsetTmz = this.offsetTmz.sort();
        //this.loadJobTitles();
        this.route.params.subscribe((params) => {
            if (params) {
                var id = params['id'];

                if (id == undefined) {
                    id = this.modalIdData;
                }

                // 
                this.settingService.getValueById(id)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {
                        }, 1000);
                    })
                    .subscribe((response: any) => {
                        if (response.Data != null) {

                            this.model = response.Data;

                            if (this.model.Name == 'ContactPublicPageData') {

                                this.tenantSettingModel = JSON.parse(this.model.Value);

                            }

                            if (this.model.Name == "ContactEmailData") {
                                this.tenantEmailSettingModel = JSON.parse(this.model.Value);
                            }

                            var test = this.offsetTmz.filter(x => x == this.model.Value);
                            if (this.model.InputType == "checkbox") {
                                if (this.model.Value == "false") {
                                    this.model.tempValue = false;
                                } else {
                                    this.model.tempValue = true;
                                }
                            }

                            if (this.model.InputType == "image") {
                                if (this.model.Value == "" || this.model.Value == undefined || this.model.Value == null) {
                                    this.imageData = "/assets/images/upload-empty.png";
                                } else {
                                    this.imageData = this.model.Value;
                                }
                            }

                            if (this.model.Name == "DefaultJobCategories") {
                                var modelsToCheck = this.model.Value.split(',');

                                var currentUser = JSON.parse(localStorage.getItem('currentUser'));
                                //this.model.AccountId = currentUser.accountId;
                                this.tenantService.getAllJobTitles(currentUser.accountId)
                                    .catch((err: any) => {
                                        return Observable.throw(err);
                                    })
                                    .finally(() => {
                                    })
                                    .subscribe((response: any) => {

                                        this.jobTitleList = response.Data ? response.Data : [];

                                        var ggw = modelsToCheck.map(r => r.toLowerCase().replace(/\s+/g, ''));
                                        var ttw = this.jobTitleList.map((r) => ({ name: r.TitleName.toLowerCase().replace(/\s+/g, ''), id: r.Id }));

                                        var twg = ttw.filter(r => ggw.includes(r.name));
                                        twg.forEach(element => {
                                            this.jobTitleList.filter(x => x.Id == element.id)[0].isChecked = true;
                                        });

                                    });

                            }

                            if (this.model.Name == "SpecialOptions") {
                                var user = JSON.parse(localStorage.getItem('currentUser'));
                                var SiteId = +localStorage.getItem('currentSiteId');
                                this.incidentTypeService.getAllIncidentTypes(user.accountId, SiteId)
                                    .catch((err: any) => {
                                        return Observable.throw(err);
                                    })
                                    .finally(() => {
                                        setTimeout(() => {
                                            this.showSpinner = false;
                                        }, 1000);
                                    })
                                    .subscribe((responseT: any) => {
                                        this.specialOptions = (responseT.Data);

                                        var array = this.model.Value.split(',');
                                        array.forEach(r => {
                                            var element = this.specialOptions.filter(t => "" + t.Id == r);
                                            if (element != null) {
                                                element[0].isSelected = true;
                                            }
                                        });
                                    });
                            }

                            if (this.model.Name == "PublicPageContactOptions") {
                                var user = JSON.parse(localStorage.getItem('currentUser'));
                                var SiteId = +localStorage.getItem('currentSiteId');

                                this.tenantService.getTenantBySiteId(SiteId)
                                    .catch((err: any) => {
                                        return Observable.throw(err);
                                    })
                                    .finally(() => {
                                        setTimeout(() => {
                                            //this.showSpinner = false;
                                        }, 1000);
                                    })
                                    .subscribe((responseT: any) => {
                                        // 
                                        this.publicContacts = responseT.Data.filter(x => x.IsActive);

                                        var array = this.model.Value.split(',');
                                        array.forEach(r => {
                                            var element = this.publicContacts.filter(t => "" + t.Id == r);
                                            if (element != null) {
                                                element[0].isSelected = true;
                                            }
                                        });
                                    });

                                // this.incidentTypeService.getAllIncidentTypes(user.accountId,SiteId)
                                // .catch((err: any) => {
                                //     return Observable.throw(err);
                                // })
                                // .finally(() => {
                                //         setTimeout(() => {
                                //         this.showSpinner = false;
                                //     }, 1000);
                                // })
                                // .subscribe((responseT : any) => {

                                // });  
                            }

                        }
                    });

                this.loadTenantTypes();
            }
        });



        this.loadSetting();

        this.loadIncidentTypes();
    }

    public fileChange(fileInput: any) {
        let self = this;
        let file = <File>fileInput.target.files[0];

        if (file.size > 2000000) {
            this.toastr.error(`Photo upload limits 2MB of file, this file is ${(file.size / 1024 / 1024).toFixed(2)} KB. Please choose another one.`, "Error");
            return false;
        }
        var reader = new FileReader();
        reader.onload = function() {

            self.model.extension = file.name;
            self.imageData = reader.result;
            self.model.Value = (<string>reader.result).replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
        };
        reader.onerror = function(error) {
            console.log('Error: ', error);
        };

        reader.readAsDataURL(file);
    }

    public loadTenantTypes() {

        var user = JSON.parse(localStorage.getItem('currentUser'));
        this.tenantService.getAllTenantTypes(user.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                return Observable.create(null);
            })
            .subscribe((response: any) => {
                this.tenantTypeList = response.Data ? response.Data : [];
            });
    }

    modelChangeForm() {
        var ret = this.startRondModel.description.replace('-', '');
        this.model.Value = this.startRondModel.type1 + "-" + this.startRondModel.type2 + "-" + this.startRondModel.type3 + "-" + ret;
    }
    modelChangeFormStop() {
        var ret = this.stopRondModel.description.replace('-', '');
        this.model.Value = this.stopRondModel.type1 + "-" + this.stopRondModel.type2 + "-" + this.stopRondModel.type3 + "-" + ret;
    }

    modelChangeFormOption1() {
        var ret = this.option1.name.replace('-', '');
        this.model.Value = this.option1.enabled + "-" + ret;
    }
    modelChangeFormOption2() {
        var ret = this.option2.name.replace('-', '');
        this.model.Value = this.option2.enabled + "-" + ret;
    }
    modelChangeFormOption3() {
        //var ret = this.option3.name.replace('-','');
        this.model.Value = this.option3.enabled + "-";
    }
    changeTenantSettingModel() {
        var val = JSON.stringify(this.tenantSettingModel);
        this.model.Value = val;
    }

    changeTenantEmailSettingModel() {
        var val = JSON.stringify(this.tenantEmailSettingModel);
        this.model.Value = val;
    }

    loadIncidentTypes() {
        this.incidenttypes = [];
        var user = JSON.parse(localStorage.getItem('currentUser'));
        var SiteId = +localStorage.getItem('currentSiteId');
        this.incidentTypeService.getAllIncidentTypes(user.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                this.incidenttypes = response.Data;

                this.loadCustomTypes();
                // this.toastr.success(response.Message, "Success"); 
            });
    };

    public loadType3() {
        var SiteId = +localStorage.getItem('currentSiteId');
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.type3List = [];
        this.type3Service.getAllType3(currentUser.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                this.type3List = response.Data;
                if (this.model.InputType == "form") {
                    if (this.model.Name == "StartRond") {
                        var res = this.model.Value.split("-");
                        // 
                        this.startRondModel.type1 = res[0];
                        this.startRondModel.type2 = res[1];
                        this.startRondModel.type3 = res[2];
                        this.startRondModel.description = res[3];
                    } else if (this.model.Name == "StopRond") {
                        var res = this.model.Value.split("-");
                        // 
                        this.stopRondModel.type1 = res[0];
                        this.stopRondModel.type2 = res[1];
                        this.stopRondModel.type3 = res[2];
                        this.stopRondModel.description = res[3];
                    } else if (this.model.Name == "Option1") {

                        var res = this.model.Value.split("-");

                        this.option1.enabled = (res[0] === 'true');
                        this.option1.name = res[1];
                    }
                    else if (this.model.Name == "Option2") {
                        var res = this.model.Value.split("-");
                        this.option2.enabled = (res[0] === 'true');
                        this.option2.name = res[1];
                    }
                    else if (this.model.Name == "Option3") {

                        var res = this.model.Value.split("-");
                        this.option3.enabled = (res[0] === 'true');

                    }
                }
                // this.toastr.success(response.Message, "Success"); 
            });
    }

    loadCustomTypes() {
        this.customTypes = [];
        var user = JSON.parse(localStorage.getItem('currentUser'));
        var SiteId = +localStorage.getItem('currentSiteId');
        this.customTypeService.getAllCustomTypes(user.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                this.customTypes = response.Data;
                this.loadType3();
                // this.toastr.success(response.Message, "Success"); 
            });
    };

    loadSetting() {
        //this.currentUser;
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.settingService.getValue("type1", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type1 = response.Data.Value;
                }
            });


        this.settingService.getValue("type2", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type2 = response.Data.Value;
                }
            });


        this.settingService.getValue("type3", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type3 = response.Data.Value;
                }

            });

    }

    changeSelected(item: any) {
        item.isSelected = !item.isSelected

        this.model.Value = "";
        this.specialOptions.forEach(x => {
            if (x.isSelected) {
                this.model.Value += x.Id + ",";
            }
        });
    };

    changeSelectedPublicOptions(item: any) {
        // 
        item.isSelected = !item.isSelected

        this.model.Value = "";
        this.publicContacts.forEach(x => {
            if (x.isSelected) {
                this.model.Value += x.Id + ",";
            }
        });

    };

    public loadJobTitles() {

    }

    changeJobTitle(item: any) {
        this.model.Value = item.TitleName;

        this.jobTitleList.filter(v => v.Id == item.Id)[0].isChecked = !this.jobTitleList.filter(v => v.Id == item.Id)[0].isChecked;
    }
    public saveChanges() {
        this.showSpinner = true;
        if (this.model.Name == 'DefaultJobCategories') {

            var selected = this.jobTitleList.filter(v => v.isChecked).map(r => r.TitleName);

            this.model.Value = "";
            selected.forEach(el => {
                this.model.Value += el.toLowerCase().replace(/\s+/g, '') + ",";
                this.model.tempValue = this.model.Value;
                this.model.SiteId = 0;
            });

        }

        if (this.model.Name == 'ContactPublicPageData') {
            var val = JSON.stringify(this.tenantSettingModel);
            this.model.Value = val;
        }

        if (this.model.Name == 'ContactEmailData') {
            var val = JSON.stringify(this.tenantEmailSettingModel);
            this.model.Value = val;
        }

        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.model.AccountId = currentUser.accountId;
        var moduleId = localStorage.getItem('currentModuleId');
        this.model.ModuleId = +moduleId;

        if (localStorage.getItem('currentSiteId') != null) {
            this.model.SiteId = +localStorage.getItem('currentSiteId');
        }

        this.settingService.Save(this.model)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {

                //   this.toastr.success(response.Message, "Success"); 
                //this.ngOnInit();
                // this.router.navigate([`/settings`]); 
                this.activeModal.close("");
            });
    }

    closeModal() {
        this.activeModal.close("");
    };

    editSetting() {
        throw new Error("not Implemented"); // todo: not implemented
    }
}



// WEBPACK FOOTER //
// ./src/app/components/setting/setting-edit.component.ts